import React, { useState, useEffect } from "react";
import { Document, Packer, Header, HeightRule,Paragraph, TextRun, convertInchesToTwip, PageNumber,SimpleField,NumberFormat, Table, TableRow, Footer, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign, VerticalPositionAlign, VerticalPositionRelativeFrom, HorizontalPositionAlign, HorizontalPositionRelativeFrom, TextWrappingType, } from "docx";
import { saveAs } from "file-saver";
import "./VTList.css";
import { API_URL } from "./API";


const VTList = ({ goBack, project, updateChecklist, formData, clearAllFormData }) => {
  const checkpoints = [
    "All PT quantity, rating, type & make are as per approved drawings.",
    "No physical damage to any of the PT.",
    "Inter-panel wiring from PTs to disconnect or Terminal blocks in panel is as per approved drawing.",
    "PT primary neutral terminals are properly earthed.",
    "PT wiring ferrules are as per drawing.",
    "All PT connections are properly tightened.",
    "Primary Fuse rating is as per the drawing and fuses are healthy."
  ];

const [checklist, setChecklist] = useState(() => {

  try {
    const savedChecklistData = localStorage.getItem('vt_checklist_data');
    if (savedChecklistData) {
      const parsedChecklistData = JSON.parse(savedChecklistData);
      if (Array.isArray(parsedChecklistData) && parsedChecklistData.length === checkpoints.length) {
        console.log("✓ Loaded checklist from localStorage:", parsedChecklistData);
        return parsedChecklistData;
      }
    }
  } catch (error) {
    console.error('Error loading checklist from localStorage:', error);
  }
  

  if (formData && formData.checklistData && Array.isArray(formData.checklistData) && 
      formData.checklistData.length === checkpoints.length) {
    console.log("✓ Loaded checklist from formData:", formData.checklistData);
    
    try {
      localStorage.setItem('vt_checklist_data', JSON.stringify(formData.checklistData));
    } catch (error) {
      console.error('Error saving checklist to localStorage:', error);
    }
    return formData.checklistData;
  }
  

  return Array(checkpoints.length).fill("");
});


useEffect(() => {
  try {
    const savedChecklistData = localStorage.getItem('vt_checklist_data');
    if (savedChecklistData) {
      const parsedChecklistData = JSON.parse(savedChecklistData);
      if (Array.isArray(parsedChecklistData) && parsedChecklistData.length === checkpoints.length) {
      
        const hasChanges = parsedChecklistData.some((item, index) => item !== checklist[index]);
        if (hasChanges) {
          console.log("Syncing checklist from localStorage on mount");
          setChecklist(parsedChecklistData);
        }
      }
    } else if (formData?.checklistData && Array.isArray(formData.checklistData) && 
               formData.checklistData.length === checkpoints.length) {
      const hasChanges = formData.checklistData.some((item, index) => item !== checklist[index]);
      if (hasChanges) {
        console.log("Syncing checklist from formData on mount");
        setChecklist(formData.checklistData);
        localStorage.setItem('vt_checklist_data', JSON.stringify(formData.checklistData));
      }
    }
  } catch (error) {
    console.error('Error syncing checklist data on mount:', error);
  }
}, [formData]);



  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: "" 
  });

 


  const diagnoseLocalStorageData = () => {
    console.log("=== DIAGNOSING LOCALSTORAGE DATA ===");
    
    const keysToCheck = [
      'vtFormData',
      'vt_insulation_data',
      'vt_winding_resistance_data',
      'vt_polarity_check_data',
      'vtRatioTestData',
      'vt_checklist_data'
    ];

    keysToCheck.forEach(key => {
      const data = localStorage.getItem(key);
      console.log(`${key}:`, data ? `Found (${data.length} chars)` : 'Not found');
      if (data) {
        try {
          const parsed = JSON.parse(data);
          console.log(`${key} parsed:`, parsed);
        } catch (e) {
          console.error(`${key} parse error:`, e);
        }
      }
    });
    
    console.log("=== END DIAGNOSIS ===");
  };


useEffect(() => {
  if (updateChecklist && typeof updateChecklist === 'function') {
    updateChecklist(checklist);
  }
}, [checklist]);


useEffect(() => {
  try {
    console.log("Saving checklist to localStorage:", checklist);
    localStorage.setItem('vt_checklist_data', JSON.stringify(checklist));
    

    const vtFormDataStr = localStorage.getItem('vtFormData');
    if (vtFormDataStr) {
      const vtFormData = JSON.parse(vtFormDataStr);
      vtFormData.checklistData = checklist;
      localStorage.setItem('vtFormData', JSON.stringify(vtFormData));
    }
  } catch (error) {
    console.error("Error saving checklist to localStorage:", error);
  }
}, [checklist]);



  useEffect(() => {
    try {
      localStorage.setItem('vt_checklist_data', JSON.stringify(checklist));
    } catch (error) {
      console.error("Error saving checklist to localStorage:", error);
    }
  }, [checklist]);

  
  useEffect(() => {
    try {
      const savedChecklistData = localStorage.getItem('vt_checklist_data');
      if (savedChecklistData) {
        const parsedChecklistData = JSON.parse(savedChecklistData);
        if (Array.isArray(parsedChecklistData) && parsedChecklistData.length === checkpoints.length) {
          setChecklist(parsedChecklistData);
        }
      }

      const localNavbarData = localStorage.getItem('navbarData'); 
      const localProjectData = localStorage.getItem('createReportData');
      
      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }
    
      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        setProjectDetails({
          subProjectName: parsedProjectData.sub_project_name || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        });
      }
    } catch (error) {
      console.error("Error loading data from localStorage:", error);
      setErrorMessage("Failed to load saved data");
    }
  }, []);

  const loadAllFormDataFromStorage = () => {
    try {
     
      const vtFormData = localStorage.getItem('vtFormData');
      let generalData = {};
      let windingValue = "";
      let windingDetailsArray = [];
      
      if (vtFormData) {
        const parsedVTFormData = JSON.parse(vtFormData);
        generalData = parsedVTFormData;
        windingValue = parsedVTFormData.winding || "";
        windingDetailsArray = parsedVTFormData.windingDetails || [];
      }

      
      const insulationData = localStorage.getItem('vt_insulation_data');
      const windingResistanceData = localStorage.getItem('vt_winding_resistance_data');
      const polarityCheckData = localStorage.getItem('vt_polarity_check_data');
      const ratioTestData = localStorage.getItem('vtRatioTestData');

      
      let parsedInsulationData = [];
      let parsedWindingResistanceData = [];
      let parsedPolarityCheckData = [];
      let parsedRatioTestData = {};

      try {
        parsedInsulationData = insulationData ? JSON.parse(insulationData) : [];
        if (!Array.isArray(parsedInsulationData)) {
          console.warn("InsulationData is not an array, converting to array");
          parsedInsulationData = parsedInsulationData ? [parsedInsulationData] : [];
        }
      } catch (e) {
        console.error("Error parsing insulationData:", e);
        parsedInsulationData = [];
      }

      try {
        parsedWindingResistanceData = windingResistanceData ? JSON.parse(windingResistanceData) : [];
        if (!Array.isArray(parsedWindingResistanceData)) {
          console.warn("WindingResistanceData is not an array, converting to array");
          parsedWindingResistanceData = parsedWindingResistanceData ? [parsedWindingResistanceData] : [];
        }
      } catch (e) {
        console.error("Error parsing windingResistanceData:", e);
        parsedWindingResistanceData = [];
      }

      try {
        parsedPolarityCheckData = polarityCheckData ? JSON.parse(polarityCheckData) : [];
        if (!Array.isArray(parsedPolarityCheckData)) {
          console.warn("PolarityCheckData is not an array, converting to array");
          parsedPolarityCheckData = parsedPolarityCheckData ? [parsedPolarityCheckData] : [];
        }
      } catch (e) {
        console.error("Error parsing polarityCheckData:", e);
        parsedPolarityCheckData = [];
      }

      try {
        parsedRatioTestData = ratioTestData ? JSON.parse(ratioTestData) : {};
        if (typeof parsedRatioTestData !== 'object') {
          console.warn("RatioTestData is not an object, resetting to empty object");
          parsedRatioTestData = {};
        }
      } catch (e) {
        console.error("Error parsing ratioTestData:", e);
        parsedRatioTestData = {};
      }

      
      const consolidatedData = {
        general: {
          
          ...generalData,
          
          winding: windingValue,
          windingDetails: windingDetailsArray,
          insulationData: parsedInsulationData,
          windingResistance: parsedWindingResistanceData,
          polarityCheck: parsedPolarityCheckData,
          ratioTestData: parsedRatioTestData,
          checklistData: checklist
        }
      };

      return consolidatedData;
    } catch (error) {
      console.error("Error loading form data from localStorage:", error);
      return {
        general: {
          winding: "",
          windingDetails: [],
          insulationData: [],
          windingResistance: [],
          polarityCheck: [],
          ratioTestData: {},
          checklistData: checklist
        }
      };
    }
  };

const handleSelectChange = (index, value) => {
  const updatedChecklist = [...checklist];
  updatedChecklist[index] = value;
  setChecklist(updatedChecklist);
  
  console.log("Checklist updated:", updatedChecklist);
  

  try {
    localStorage.setItem('vt_checklist_data', JSON.stringify(updatedChecklist));
    
  
    const vtFormDataStr = localStorage.getItem('vtFormData');
    if (vtFormDataStr) {
      const vtFormData = JSON.parse(vtFormDataStr);
      vtFormData.checklistData = updatedChecklist;
      localStorage.setItem('vtFormData', JSON.stringify(vtFormData));
    }
  } catch (error) {
    console.error("Error saving checklist to localStorage:", error);
  }
  

  if (updateChecklist && typeof updateChecklist === 'function') {
    updateChecklist(updatedChecklist);
  }
};

  const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

const clearAllStorageData = () => {
  try {
    const keysToRemove = [
     
      'vtFormData',
      
      
      'vt_insulation_data',
      
  
      'vt_winding_resistance_data',
      'vt_polarity_check_data',
      
     
      'vtRatioTestData',
      

      'vt_checklist_data',
      'vt_list_autosave',
      

      'vtInspectionReportWord',
      'createReportData',
      'navbarData',
      'formData',
      'checklistData',
      'windingData',
      'windingDetails',
      'insulationData',
      'windingResistance',
      'polarityCheck',
      'ratioTestData',
      'generalFormData'
    ];
    

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`Removed ${key} from localStorage`);
    });

    console.log("✓ All form data cleared from localStorage");
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
};






const resetAllFormStates = () => {
  
  const emptyChecklist = Array(checkpoints.length).fill("");
  setChecklist(emptyChecklist);

 
  try {
    localStorage.setItem('vt_checklist_data', JSON.stringify(emptyChecklist));
  } catch (error) {
    console.error("Error resetting checklist:", error);
  }
  

  setProjectDetails({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });
  

  setFormSubmitted(false);
  setErrorMessage("");
  

  if (clearAllFormData && typeof clearAllFormData === 'function') {
    clearAllFormData();
  }
  

  try {
    const vtFormDataStr = localStorage.getItem('vtFormData');
    if (vtFormDataStr) {
      const vtFormData = JSON.parse(vtFormDataStr);
      vtFormData.winding = ""; 
      vtFormData.windingDetails = []; 
      localStorage.setItem('vtFormData', JSON.stringify(vtFormData));
    }
  } catch (error) {
    console.error("Error clearing winding data:", error);
  }
  
  console.log("✓ All form states have been reset including winding selection");
};


  const validateAndCleanData = (data) => {
    const cleanData = {};
    
    cleanData.equipment_name = String(data.equipment_name || "VT");
    cleanData.test_date = String(data.test_date || new Date().toISOString().split('T')[0]);
    cleanData.category_name = String(data.category_name || "Category");
    cleanData.subcategory_name = String(data.subcategory_name || "Subcategory");
    cleanData.sub_project_name = String(data.sub_project_name || "Project");
    cleanData.location = String(data.location || "");
    
    let projectId = data.project_id;
    if (typeof projectId === 'string') {
      projectId = parseInt(projectId.replace(/\D/g, ''));
    }
    cleanData.project_id = Number.isInteger(projectId) && projectId > 0 ? projectId : 1;
    
    if (data.report_file && typeof data.report_file === 'object') {
      cleanData.report_file = {
        report_word: String(data.report_file.report_word || ""),
        filename: String(data.report_file.filename || `VT_Test_Report_${Date.now()}.docx`),
        file_type: String(data.report_file.file_type || "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
      };
    }

    if (data.test_data && typeof data.test_data === 'object') {
      cleanData.test_data = data.test_data;
    }
    
    return cleanData;
  };


  const convertArrayToDict = (array, keyPrefix = 'item') => {
    if (!array) {
      console.warn(`convertArrayToDict: ${keyPrefix} array is null or undefined`);
      return {};
    }
    
    if (!Array.isArray(array)) {
      console.warn(`convertArrayToDict: ${keyPrefix} is not an array, attempting to convert`);
      if (typeof array === 'object') {
        return array;
      }
      return {};
    }
    
    if (array.length === 0) {
      console.warn(`convertArrayToDict: ${keyPrefix} array is empty`);
      return {};
    }
    
    const dict = {};
    array.forEach((item, index) => {
      if (item && typeof item === 'object') {
        dict[`${keyPrefix}_${index}`] = item;
      } else if (item !== null && item !== undefined) {
        dict[`${keyPrefix}_${index}`] = { value: item };
      }
    });
    
    console.log(`convertArrayToDict: Converted ${keyPrefix} array (${array.length} items) to dict:`, dict);
    return dict;
  };


  const formatChecklistData = (checklistArray) => {
    const checklistDict = {};
    checklistArray.forEach((status, index) => {
      if (index < checkpoints.length) {
        checklistDict[checkpoints[index]] = status;
      }
    });
    return checklistDict;
  };


  const formatDataForBackend = (consolidatedData) => {
    const generalData = consolidatedData.general || {};
    

    const cleanGeneral = { ...generalData };
    delete cleanGeneral.winding;
    delete cleanGeneral.windingDetails;
    delete cleanGeneral.insulationData;
    delete cleanGeneral.windingResistance;
    delete cleanGeneral.polarityCheck;
    delete cleanGeneral.ratioTestData;
    delete cleanGeneral.checklistData;


    const ensureArrayFormat = (data, dataType) => {
      if (!data) {
        console.warn(`${dataType} is null or undefined, returning empty array`);
        return [];
      }
      
      if (Array.isArray(data)) {
        console.log(`${dataType} is already an array with ${data.length} items`);
        return data;
      }
      
      if (typeof data === 'object') {
        console.log(`${dataType} is an object, converting to array`);
        const arrayData = Object.values(data);
        return arrayData.length > 0 ? arrayData : [];
      }
      
      console.warn(`${dataType} is not a valid format, returning empty array`);
      return [];
    };

   
    const formattedInsulationData = ensureArrayFormat(generalData.insulationData, 'insulationData');
    const formattedWindingResistance = ensureArrayFormat(generalData.windingResistance, 'windingResistance');
    const formattedPolarityCheck = ensureArrayFormat(generalData.polarityCheck, 'polarityCheck');
    const formattedWindingDetails = ensureArrayFormat(generalData.windingDetails, 'windingDetails');

    const formattedData = {
      general: cleanGeneral,
      winding: generalData.winding ? { value: generalData.winding } : {},
      windingDetails: formattedWindingDetails.length > 0 ? 
        convertArrayToDict(formattedWindingDetails, 'winding') : {},
      insulationData: formattedInsulationData.length > 0 ? 
        convertArrayToDict(formattedInsulationData, 'insulation') : {},
      windingResistance: formattedWindingResistance.length > 0 ? 
        convertArrayToDict(formattedWindingResistance, 'resistance') : {},
      polarityCheck: formattedPolarityCheck.length > 0 ? 
        convertArrayToDict(formattedPolarityCheck, 'polarity') : {},
      ratioTestData: generalData.ratioTestData || {},
      checklistData: formatChecklistData(generalData.checklistData || checklist)
    };

  
    console.log("Formatted data:");
    console.log("- insulationData:", formattedData.insulationData);
    console.log("- windingResistance:", formattedData.windingResistance);
    console.log("- polarityCheck:", formattedData.polarityCheck);
    console.log("- windingDetails:", formattedData.windingDetails);

    return formattedData;
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  if (updateChecklist) updateChecklist(checklist);
  setIsLoading(true);
  setErrorMessage("");
  setFormSubmitted(true);
 
  try {
    const allFormData = loadAllFormDataFromStorage();
   
    const safeFormData = formData && typeof formData === 'object' ? {
      general: formData.general || allFormData.general,
      winding: formData.winding || allFormData.winding,
      windingDetails: formData.windingDetails || allFormData.windingDetails,
      insulationData: formData.insulationData || allFormData.insulationData,
      windingResistance: formData.windingResistance || allFormData.windingResistance,
      polarityCheck: formData.polarityCheck || allFormData.polarityCheck,
      ratioTestData: formData.ratioTestData || allFormData.ratioTestData,
      checklistData: checklist
    } : allFormData;
 
    console.log("Safe form data:", safeFormData);
 
    const wordBlob = await generateWordBlob(safeFormData, checklist);
   
    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);
   
    reader.onloadend = async () => {
      try {
        const base64data = reader.result;
       
        localStorage.setItem('vtInspectionReportWord', base64data);
       
        const currentDate = new Date().toISOString().split('T')[0];
        const formLocation = safeFormData.general.location || "";
       
       
        const getProjectId = () => {
          console.log("=== Starting project_id extraction ===");
         
         
          if (project?.project_id) {
            const id = parseInt(project.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from project prop:", id);
              return id;
            }
          }
         
       
          if (projectDetails?.projectId) {
            const id = parseInt(projectDetails.projectId);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from projectDetails:", id);
              return id;
            }
          }
         
         
          try {
            const createReportData = localStorage.getItem('createReportData');
            if (createReportData) {
              const parsedData = JSON.parse(createReportData);
              if (parsedData.project_id) {
                const id = parseInt(parsedData.project_id);
                if (!isNaN(id) && id > 0) {
                  console.log("✓ Using project_id from createReportData:", id);
                  return id;
                }
              }
            }
          } catch (error) {
            console.error("Error parsing createReportData:", error);
          }
         
       
          if (safeFormData.general?.project_id) {
            const id = parseInt(safeFormData.general.project_id);
            if (!isNaN(id) && id > 0) {
              console.log("✓ Using project_id from form data:", id);
              return id;
            }
          }
         
       
          if (safeFormData.general?.reportNo) {
            const id = parseInt(String(safeFormData.general.reportNo).replace(/\D/g, ''));
            if (!isNaN(id) && id > 0) {
              console.log("⚠ Using project_id from reportNo:", id);
              return id;
            }
          }
         
          console.error(" Could not find valid project_id!");
          alert("Warning: Could not determine project ID. Report may be saved incorrectly.");
          return 1;
        };
       
        const projectId = getProjectId();
        console.log("=== Final project_id selected:", projectId, "===");
       
        const apiRequestData = {
          equipment_name: String(projectDetails.equipmentName || safeFormData.general.equipment || "VT"),
          test_date: String(safeFormData.general.date || currentDate),
          category_name: String(projectDetails.categoryName || "Category"),
          subcategory_name: String(projectDetails.subcategoryName || "Subcategory"),
          sub_project_name: String(projectDetails.subProjectName || safeFormData.general.project || "Project"),
          project_id: projectId,
          location: String(formLocation || projectDetails.location || ""),
          report_file: {  
            report_word: base64data,
            filename: `VT_Test_Report_${Date.now()}.docx`,
            file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          },
          test_data: {
            general: safeFormData.general || {},
            winding: safeFormData.winding || {},
            windingDetails: safeFormData.windingDetails || {},
            insulationData: safeFormData.insulationData || {},
            windingResistance: safeFormData.windingResistance || {},
            polarityCheck: safeFormData.polarityCheck || {},
            ratioTestData: safeFormData.ratioTestData || {},
            checklistData: Array.isArray(checklist) ? checklist : []
          }
        };
   
        console.log("=== Final API Request Data ===");
        console.log("Project ID type:", typeof apiRequestData.project_id);
        console.log("Project ID value:", apiRequestData.project_id);
   
        const response = await fetch(`${API_URL}/test_report/create_test_report`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(apiRequestData),
          mode: 'cors',
          credentials: 'same-origin',
        });
   
        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
            console.error("Detailed API Error:", errorData);
          } catch (jsonError) {
            console.error("Could not parse error response as JSON:", jsonError);
            errorData = { message: response.statusText };
          }
         
          throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
        }
   
        const result = await response.json();
        console.log('API Response:', result);
   
        alert("Data submitted successfully");
       
      } catch (error) {
        console.error("Error in Word document processing or API call:", error);
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
   
  } catch (error) {
    console.error("Error saving data:", error);
   
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server. Please check if the backend is running.");
      alert("Cannot connect to server. Please check if the backend is running.");
    } else if (error.message.includes("generateWordBlob is not defined")) {
      setErrorMessage("Word document generation function is missing. Please check your imports.");
      alert("Word document generation function is missing. Please check your imports.");
    } else {
      setErrorMessage(`Error: ${error.message}`);
      alert(`Error saving data: ${error.message}`);
    }
    setIsLoading(false);
  }
};
 


  const handleCancel = () => {
    if (window.confirm("Are you sure you want to cancel?")) {
      const emptyChecklist = Array(checkpoints.length).fill("");
      setChecklist(emptyChecklist);
      try {
        localStorage.setItem('vt_checklist_data', JSON.stringify(emptyChecklist));
      } catch (error) {
        console.error("Error clearing checklist from localStorage:", error);
      }
    }
  };



//   const handleDownloadPdf = async () => {
//   setIsLoading(true);
//   setErrorMessage("");
  
//   try {
//     // Load all form data from storage
//     const allFormData = loadAllFormDataFromStorage();
    
//     // Use safe form data
//     const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;
    
//     // Generate the Word document blob
//     const wordBlob = await generateWordBlob(safeFormData, checklist);
    
//     // Download the Word file
//     saveAs(wordBlob, 'Voltage_Test_Report.docx');
    
//     // Clear ALL localStorage data after successful download
//     clearAllStorageData();
    
//     // Reset all form states
//     resetAllFormStates();
    
//     // Show success message
//     alert("Word document downloaded successfully");
    
  
    
//   } catch (error) {
//     console.error("Error generating Word document:", error);
//     setErrorMessage(`Error generating Word document: ${error.message}`);
//     alert(`Error generating Word document: ${error.message}`);
//   } finally {
//     setIsLoading(false);
//   }
// };




const handleDownloadPdf = async () => {
  setIsLoading(true);
  setErrorMessage("");
  
  try {
    const allFormData = loadAllFormDataFromStorage();
    const safeFormData = formData && typeof formData === 'object' ? formData : allFormData;
    const wordBlob = await generateWordBlob(safeFormData, checklist);
    saveAs(wordBlob, 'Voltage_Test_Report.docx');
    
    
    localStorage.setItem('resetVTForm', 'true');
    

    clearAllStorageData();
    
    
    resetAllFormStates();
    
    alert("Word document downloaded successfully");
    
  } catch (error) {
    console.error("Error generating Word document:", error);
    setErrorMessage(`Error generating Word document: ${error.message}`);
    alert(`Error generating Word document: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
    const autoSave = () => {
      try {
        const formDataToSave = {
          checklist: checklist,
          projectDetails: projectDetails,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('vt_list_autosave', JSON.stringify(formDataToSave));
      } catch (error) {
        console.error("Auto-save failed:", error);
      }
    };

    const autoSaveInterval = setInterval(autoSave, 30000); 

    return () => clearInterval(autoSaveInterval);
  }, [checklist, projectDetails]);

  
  useEffect(() => {
    try {
      const autoSavedData = localStorage.getItem('vt_list_autosave');
      if (autoSavedData) {
        const parsedData = JSON.parse(autoSavedData);
        if (parsedData.checklist && Array.isArray(parsedData.checklist) && parsedData.checklist.length === checkpoints.length) {
          setChecklist(parsedData.checklist);
        }
        if (parsedData.projectDetails) {
          setProjectDetails(prev => ({
            ...prev,
            ...parsedData.projectDetails
          }));
        }
      }
    } catch (error) {
      console.error("Error loading auto-saved data:", error);
    }
  }, []);
  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formSubmitted) {
        clearAllStorageData();
      }
    };

    const handleUnload = () => {
      if (formSubmitted) {
        clearAllStorageData();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [formSubmitted]);




const generateWordBlob = (formData, checklistData) => {
  return new Promise(async (resolve, reject) => {
    try {
     
      const vtFormData = formData.general || {};
      const vtWindingData = formData.windingDetails || [];
      const vtInsulationData = formData.insulationData || [];
      const vtWindingResistance = formData.windingResistance || [];
     
      const vtRatioTestData = formData.ratioTestData || {};

     
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, backgroundColor: "000000" }
      };

     
      const formatFieldLabel = (key) => {
        const specialCases = {
          'yom': 'Year of Manufacture',
          'il': 'Insulation Level',
          'vf': 'Voltage Factor',
          'frequency': 'Frequency',
          'type': 'Type',
          'specNo': 'Specification No',
          'insulationClass': 'Insulation Class',
          'make': 'Make',
          'serialNo': 'Serial Number',
          'reportNo': 'Report No'
        };
        
        if (specialCases[key]) {
          return specialCases[key];
        }
        
        return key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase())
          .trim();
      };

const getRemainingFormFields = (formData) => {
  const fields = [];
  const excludeFields = ['description', 'project', 'customer', 'client', 'date', 'reportNo', 'location'];
  
 
  const fieldOrder = [
    'yom', 'make', 'serialNo', 'il', 'vf', 'frequency', 'type', 
    'specNo', 'insulationClass'
  ];
  
  
  fieldOrder.forEach(key => {
    if (!excludeFields.includes(key)) {
      const value = formData.hasOwnProperty(key) && formData[key] !== null && formData[key] !== undefined 
        ? String(formData[key]) 
        : ""; 
      
      fields.push({
        label: formatFieldLabel(key),
        value: value
      });
    }
  });
  
 
  Object.keys(formData).forEach(key => {
    if (!fieldOrder.includes(key) && 
        !excludeFields.includes(key) &&
        formData[key] !== null && 
        formData[key] !== undefined && 
        formData[key] !== '' && 
        formData[key] !== 'N/A' &&
        String(formData[key]).trim() !== '') {
      fields.push({
        label: formatFieldLabel(key),
        value: String(formData[key])
      });
    }
  });
  
  return fields;
};

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

      const remainingFields = getRemainingFormFields(vtFormData);

     
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
              console.warn("Could not convert image to base64:", error);
              resolve(null);
            }
          };
          img.onerror = function() {
            console.warn("Could not load image from URL:", url);
            resolve(null);
          };
          img.src = url;
        });
      };

     
    
      const createLightWatermark = (base64Data) => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
              
              ctx.globalAlpha = 0.15; 
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
            console.warn("Could not create light watermark:", error);
            resolve(null);
          }
        });
      };

      
      const documentSections = [];

      
      
const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
     
   const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 
      
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
       
        createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {
        
     
      const headerElements = [];

      if (logoBase64) {
        headerElements.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new ImageRun({
                            data: logoBase64,
                            transformation: {
                              width: 80,
                              height: 80
                            }
                          })
                        ],
                        alignment: AlignmentType.CENTER,
                      })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                    borders: {
                      top: { style: BorderStyle.SINGLE, size: 1 },
                      bottom: { style: BorderStyle.SINGLE, size: 1 },
                      left: { style: BorderStyle.SINGLE, size: 1 },
                      right: { style: BorderStyle.SINGLE, size: 1 }
                    },
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    margins: {
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0
                    }
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "PIE POWER PRIVATE LIMITED",
                            font: "Times New Roman",
                            color:"#1e402c",
                            bold: true,
                            size: 36
                          })
                        ],
                        alignment: AlignmentType.CENTER
                      }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                            font: "helvetica",
                            size: 20
                          })
                        ],
                        alignment: AlignmentType.CENTER
                      }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                            font: "helvetica",
                            size: 20
                          })
                        ],
                        alignment: AlignmentType.CENTER
                      })
                    ],
                    borders: {
                      top: { style: BorderStyle.SINGLE, size: 1 },
                      bottom: { style: BorderStyle.SINGLE, size: 1 },
                      left: { style: BorderStyle.SINGLE, size: 1 },
                      right: { style: BorderStyle.SINGLE, size: 1 }
                    },
                    width: { size: 80, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ]
          })
        );
      } else {
       
        headerElements.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "PIE POWER PRIVATE LIMITED",
                font: "Times New Roman",
                color:"#1e402c",
                bold: true,
                size: 36
              })
            ],
            alignment: AlignmentType.CENTER
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "VISAKHAPATNAM, ANDHRA PRADESH, INDIA-531163",
                font: "helvetica",
                size: 15
              })
            ],
            alignment: AlignmentType.CENTER
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                font: "helvetica",
                size: 15
              })
            ],
            alignment: AlignmentType.CENTER
          })
        );
      }

      headerElements.push(new Paragraph({ text: "" })); 
      documentSections.push(...headerElements);

      

    
      documentSections.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "Description", font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  width: { size: 20, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "VOLTAGE INSPECTION / TEST REPORT", font: "Courier New",bold: true })] })],
                  borders: tableBorders,
                  width: { size: 50, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "Date", font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  width: { size: 15, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: (vtFormData.date || ""), font: "Courier New" })] })],
                  borders: tableBorders,
                  width: { size: 15, type: WidthType.PERCENTAGE }
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "Project", font: "Courier New", bold: true })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: (vtFormData.project || ""), font: "Courier New", bold: true })] })],
                  borders: tableBorders
                }),
                
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "Report No", font: "Courier New",bold: true   })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:  (vtFormData.reportNo || ""), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:"Customer", font: "Courier New", bold: true })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: (vtFormData.customer || ""), font: "Courier New", bold: true })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                  borders: tableBorders
                })
              ]
            }),
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "Client", font: "Courier New", bold: true })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text:  (vtFormData.client || ""), font: "Courier New", bold: true })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ children: [new TextRun({ text: "" })] })],
                  borders: tableBorders
                })
              ]
            })
          ]
        })
      );

      documentSections.push(new Paragraph({ text: "" }));


     documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "LOCATION : ",
                font: "Courier New",
                bold: true,
                size: 24
              }),
              new TextRun({
                text: vtFormData.location || '',
                font: "Courier New",
                size: 24
              })
            ]
          })
        );
      
        documentSections.push(new Paragraph({ text: "" }));
      
      if (remainingFields.length > 0) {

        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "NAME PLATE DETAILS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );
        const fieldRows = [];
        

        remainingFields.forEach(field => {
          fieldRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:  field.label, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  width: { size: 50, type: WidthType.PERCENTAGE },
                  
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: field.value, font: "Courier New" })] })],
                  borders: tableBorders,
                  width: { size: 50, type: WidthType.PERCENTAGE }
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: fieldRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 
      }

      
      if (formData.winding) {
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "WINDING INFORMATION",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          }),
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + "Winding Type", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    shading: {
              fill: "a6a6a6" 
            },
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + formData.winding, font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  })
                ]
              })
            ]
          })
        );
        documentSections.push(new Paragraph({ text: "" })); 
      }

     
      if (vtWindingData.length > 0) {
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "WINDING DETAILS",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        vtWindingData.forEach((detail, idx) => {
          documentSections.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: `Winding ${idx + 1}`,
                  font: "Courier New",
                  bold: true,
                  size: 20
                })
              ]
            }),
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + "Ratio", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
              fill: "a6a6a6" 
            },
                      width: { size: 25, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + (detail.ratio || ""), font: "Courier New" })] })],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + "VA/PH", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
              fill: "a6a6a6" 
            },
                      width: { size: 25, type: WidthType.PERCENTAGE }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + (detail.vaPh || ""), font: "Courier New" })] })],
                      borders: tableBorders,
                      width: { size: 25, type: WidthType.PERCENTAGE }
                    })
                  ]
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + "Class", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
              fill: "a6a6a6" 
            }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + (detail.class || ""), font: "Courier New" })] })],
                      borders: tableBorders
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + "Volts", font: "Courier New", bold: true })] })],
                      borders: tableBorders,
                      shading: {
              fill: "a6a6a6" 
            }
                    }),
                    new TableCell({
                      children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + (detail.volts || ""), font: "Courier New" })] })],
                      borders: tableBorders
                    })
                  ]
                })
              ]
            })
          );
        });
        documentSections.push(new Paragraph({ text: "" })); 
      }

     
      if (vtInsulationData.length > 0) {
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "INSULATION RESISTANCE MEASUREMENT",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        const insulationHeaders = new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Reference", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 25, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Applied Voltage", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 20, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " R-ph", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6"
            },
              width: { size: 18.33, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Y-ph", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 18.33, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " B-ph", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6"
            },
              width: { size: 18.33, type: WidthType.PERCENTAGE }
            })
          ]
        });

        const generateReferences = (winding) => {
          const refMap = {
            "1a - 1n": ["Primary - Earth", "Primary - Core 1", "Core 1 - Earth"],
            "2a - 2n": ["Primary - Earth", "Primary - Core 1", "Primary - Core 2", "Core 1 - Core 2", "Core 1 - Earth", "Core 2 - Earth"],
            "3a - 3n": ["Primary - Earth", "Primary - Core 1", "Primary - Core 2", "Primary - Core 3", "Core 1 - Core 2", "Core 1 - Core 3", "Core 2 - Core 3", "Core 1 - Earth", "Core 2 - Earth", "Core 3 - Earth"],
            "4a - 4n": ["Primary - Earth", "Primary - Core 1", "Primary - Core 2", "Primary - Core 3", "Primary - Core 4", "Core 1 - Core 2", "Core 1 - Core 3", "Core 1 - Core 4", "Core 2 - Core 3", "Core 2 - Core 4", "Core 3 - Core 4", "Core 1 - Earth", "Core 2 - Earth", "Core 3 - Earth", "Core 4 - Earth"],
            "da - dn": ["Primary - Earth", "Primary - Core 1", "Primary - Core 2", "Primary - Core 3", "Primary - Core 4", "Primary - Core 5", "Core 1 - Core 2", "Core 1 - Core 3", "Core 1 - Core 4", "Core 1 - Core 5", "Core 2 - Core 3", "Core 2 - Core 4", "Core 2 - Core 5", "Core 3 - Core 4", "Core 3 - Core 5", "Core 4 - Core 5", "Core 1 - Earth", "Core 2 - Earth", "Core 3 - Earth", "Core 4 - Earth", "Core 5 - Earth"]
          };

          const combined = winding?.split("&").map(w => w.trim()) || [];
          const result = combined.flatMap(w => refMap[w] || []);
          return result.length > 0 ? result : [];
        };

        const references = generateReferences(formData.winding);
        const insulationRows = [insulationHeaders];

        vtInsulationData.forEach((item, idx) => {
          const reference = references[idx] || `Reference ${idx + 1}`;

          const formatWithUnit = (phaseData, unitField) => {
            if (!phaseData) return "";
            if (typeof phaseData === 'object' && phaseData.value !== undefined) {
              return `${phaseData.value || ""} ${phaseData.unit || ""}`.trim();
            }
            const value = phaseData;
            const unit = item[unitField] || "";
            return `${value || ""} ${unit || ""}`.trim();
          };

          insulationRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + reference, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + (item.appliedVoltage || ""), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + formatWithUnit(item.rPh, 'rPhUnit'), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + formatWithUnit(item.yPh, 'yPhUnit'), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + formatWithUnit(item.bPh, 'bPhUnit'), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: insulationRows
          })
        );
        documentSections.push(new Paragraph({ text: "" })); 
      }

     
      if (vtWindingResistance.length > 0) {
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "WINDING RESISTANCE",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        const windingResHeaders = new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Reference", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 25, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " R-ph", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 25, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Y-ph", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 25, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " B-ph", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 25, type: WidthType.PERCENTAGE }
            })
          ]
        });

        const windingMap = {
          "1a - 1n": ["Core 1(da-dn)", "A - N"],
          "2a - 2n": ["Core 1(1a-1n)", "Core 2(da-dn)", "A - N"],
          "3a - 3n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(da-dn)", "A - N"],
          "4a - 4n": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(da-dn)", "A - N"],
          "da - dn": ["Core 1(1a-1n)", "Core 2(2a-2n)", "Core 3(3a-3n)", "Core 4(4a-4n)", "Core 5(da-dn)", "A - N"]
        };

        const coreRefs = windingMap[formData.winding] || [];
        const windingResRows = [windingResHeaders];

        vtWindingResistance.forEach((item, idx) => {
          const reference = idx < coreRefs.length ? coreRefs[idx] : `Reference ${idx + 1}`;

          windingResRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + reference, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + `${item.rPh?.value || ""} ${item.rPh?.unit || ""}`.trim(), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + `${item.yPh?.value || ""} ${item.yPh?.unit || ""}`.trim(), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + `${item.bPh?.value || ""} ${item.bPh?.unit || ""}`.trim(), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: windingResRows
          })
        );
        
        documentSections.push(new Paragraph({ text: "" })); 
      }

     
    const vtPolarityCheck = formData.polarityCheck || [];
    if (vtPolarityCheck.length > 0) {
      documentSections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "POLARITY CHECK",
              font: "Courier New",
              bold: true,
              size: 24
            })
          ]
        })
      );

      const polarityHeaders = new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Reference", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 25, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " R-ph", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 25, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Y-ph", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 25, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " B-ph", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 25, type: WidthType.PERCENTAGE }
          })
        ]
      });

      const polarityRows = [polarityHeaders];

      vtPolarityCheck.forEach((item, idx) => {
        const reference = `Core ${idx + 1}`;
        polarityRows.push(
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + reference, font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6" 
            }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(item.rPh), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(item.yPh), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(item.bPh), font: "Courier New" })] })],
                borders: tableBorders
              })
            ]
          })
        );
      });

      documentSections.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: polarityRows
        })
      );

      documentSections.push(new Paragraph({ text: "" }));
    }

    
    if (vtRatioTestData && Object.keys(vtRatioTestData).length > 0) {
      documentSections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "RATIO TEST",
              font: "Courier New",
              bold: true,
              size: 24
            })
          ]
        })
      );
      documentSections.push(new Paragraph({ text: "" }));

      const coreKeys = Object.keys(vtRatioTestData).filter(key => 
        !isNaN(key) && vtRatioTestData[key]
      );

      coreKeys.forEach(coreKey => {
        const coreNum = parseInt(coreKey);
        const coreData = vtRatioTestData[coreKey];
        
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: `CORE ${coreNum}`,
                font: "Courier New",
                bold: true,
                size: 20
              })
            ]
          })
        );

        const ratioHeaders = new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Applied Voltage (V)", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 15, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " R-ph Core", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 12.5, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " R-ph % Error", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 12.5, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Y-ph Core", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 12.5, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Y-ph % Error", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 12.5, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " B-ph Core", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6"
            },
              width: { size: 12.5, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " B-ph % Error", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: {
              fill: "a6a6a6" 
            },
              width: { size: 12.5, type: WidthType.PERCENTAGE }
            })
          ]
        });

        const ratioRows = [ratioHeaders];
        const testVoltages = Object.keys(coreData).filter(key => !isNaN(key));

        testVoltages.forEach(voltage => {
          const voltageData = coreData[voltage];
          
          ratioRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + voltage, font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  shading: {
              fill: "a6a6a6" 
            }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(voltageData['R-ph']?.core), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(voltageData['R-ph']?.error), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(voltageData['Y-ph']?.core), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(voltageData['Y-ph']?.error), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(voltageData['B-ph']?.core), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + safeToString(voltageData['B-ph']?.error), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: ratioRows
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 
      });
    }

   

    if (checkpoints && checkpoints.length > 0) {
      documentSections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "PT CHECK LIST",
              font: "Courier New",
              bold: true,
              size: 24
            })
          ]
        })
      );

      const checklistHeaders = new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Checkpoint", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 80, type: WidthType.PERCENTAGE }
          }),
          new TableCell({
            children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " Status", font: "Courier New", bold: true })] })],
            borders: tableBorders,
            shading: {
              fill: "a6a6a6" 
            },
            width: { size: 20, type: WidthType.PERCENTAGE }
          })
        ]
      });

      const checklistRows = [checklistHeaders];

      checkpoints.forEach((checkpoint, idx) => {
        const status = checklistData && checklistData[idx] ? checklistData[idx] : "Not Checked";
        
        checklistRows.push(
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ children: [new TextRun({ text: " " + checkpoint, font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: {
              fill: "a6a6a6"
            }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: " " + status, font: "Courier New" })] })],
                borders: tableBorders
              })
            ]
          })
        );
      });

      documentSections.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: checklistRows
        })
      );
    }

    documentSections.push(new Paragraph({ text: "" })); 

   const convertInchesToTwip = (inches) => {
                   return Math.round(inches * 1440);
                 };
         
                 const footerTable = new Table({
                   width: { size: 100, type: WidthType.PERCENTAGE, },
                   alignment: AlignmentType.LEFT,
                   rows: [
                     new TableRow({
                       height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
                       children: [
                         new TableCell({
                           children: [
                             new Paragraph({
                               alignment: AlignmentType.LEFT,
                               spacing: { before: 0, after: 0 },
                               children: [
                                 new TextRun({
                                   text: "Pie Power",
                                   font: "Courier New",
                                   bold: true,
                                   size: 18
                                 })
                               ]
                             }),
                           ],
                           borders: tableBorders,
                           width: { size: 25, type: WidthType.PERCENTAGE },
                           verticalAlign: VerticalAlign.TOP,
                           margins: {
                             top: convertInchesToTwip(0.1),
                             bottom: convertInchesToTwip(0.25),
                             left: convertInchesToTwip(0.25),
                             right: convertInchesToTwip(0.25)
                           }
                         }),
                         new TableCell({
                           children: [
                             new Paragraph({
                               alignment: AlignmentType.LEFT,
                               spacing: { before: 0, after: 0 },
                               children: [
                                 new TextRun({
                                   text: "TPREL",
                                   font: "Courier New",
                                   bold: true,
                                   size: 18
                                 })
                               ]
                             }),
                           ],
                           borders: tableBorders,
                           width: { size: 25, type: WidthType.PERCENTAGE },
                           verticalAlign: VerticalAlign.TOP,
                           margins: {
                             top: convertInchesToTwip(0.1),
                             bottom: convertInchesToTwip(0.25),
                             left: convertInchesToTwip(0.25),
                             right: convertInchesToTwip(0.25)
                           }
                         }),
                         new TableCell({
                           children: [
                             new Paragraph({
                               alignment: AlignmentType.LEFT,
                               spacing: { before: 0, after: 0 },
                               children: [
                                 new TextRun({
                                   text: "TPREL",
                                   font: "Courier New",
                                   bold: true,
                                   size: 18
                                 })
                               ]
                             }),
                           ],
                           borders: tableBorders,
                           width: { size: 25, type: WidthType.PERCENTAGE },
                           verticalAlign: VerticalAlign.TOP,
                           margins: {
                             top: convertInchesToTwip(0.1),
                             bottom: convertInchesToTwip(0.25),
                             left: convertInchesToTwip(0.25),
                             right: convertInchesToTwip(0.25)
                           }
                         }),
                         new TableCell({
                           children: [
                             new Paragraph({
                               alignment: AlignmentType.LEFT,
                               spacing: { before: 0, after: 0 },
                               children: [
                                 new TextRun({
                                   text: "TPREL",
                                   font: "Courier New",
                                   bold: true,
                                   size: 18
                                 }),
                                 new SimpleField({
                                   instruction: "PAGE",
                                   children: [
                                     new TextRun({
                                       text: "1",
                                       font: "Courier New",
                                       size: 16
                                     })
                                   ]
                                 }),
                                 new SimpleField({
                                   instruction: "NUMPAGES",
                                   children: [
                                     new TextRun({
                                       text: "1",
                                       font: "Courier New",
                                       size: 16
                                     })
                                   ]
                                 })
                               ]
                             }),
                           ],
                           borders: tableBorders,
                           width: { size: 25, type: WidthType.PERCENTAGE },
                           verticalAlign: VerticalAlign.TOP,
                           margins: {
                             top: convertInchesToTwip(0.1),
                             bottom: convertInchesToTwip(0.25),
                             left: convertInchesToTwip(0.25),
                             right: convertInchesToTwip(0.25)
                           }
                         })
                       ]
                     })
                   ]
                 });  
                        

const pageBorders = {
                  pageBorderTop: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  },
                
                
                  pageBorderRight: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  },
                  pageBorderBottom: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  },
                  pageBorderLeft: {
                    style: BorderStyle.DOUBLE,
                    size: 6,
                    color: "000000",
                    space: 3
                  }
                };
                
                      const doc = new Document({
                  sections: [
                    {
                      properties: {
                        page: {
                          margin: {
                            top: convertInchesToTwip(0.5),
                            right: convertInchesToTwip(0.5),
                            bottom: convertInchesToTwip(1.0),
                            left: convertInchesToTwip(0.5)
                          },
                          borders: pageBorders,
                          pageNumbers: {
                            start: 1,
                            formatType: NumberFormat.DECIMAL
                          }
                        }
                      },
                      footers: {
                        default: new Footer({
                          children: [
                            footerTable,
                            new Paragraph({
                              children: [
                                new TextRun({
                                  text: "Page ",
                                  font: "Courier New",
                                  size: 16
                                }),
                                new TextRun({
                                  children: [PageNumber.CURRENT],
                                  font: "Courier New",
                                  size: 16
                                }),
                                new TextRun({
                                    text: " of ",
                                    font: "Courier New",
                                    size: 16
                                  }),
                               
                                new TextRun({
                                  children: [PageNumber.TOTAL_PAGES],
                                  font: "Courier New",
                                  size: 16
                                })
                              ],
                              alignment: AlignmentType.CENTER,
                              spacing: {
                                before: 200
                              }
                            })
                          ]
                        })
                      },
                      headers: lightWatermarkBase64 ? {
                        default: new Header({
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: lightWatermarkBase64,
                                  transformation: {
                                    width: 500,
                                    height: 500
                                  },
                                  floating: {
                                    horizontalPosition: {
                                      relative: HorizontalPositionRelativeFrom.PAGE,
                                      align: HorizontalPositionAlign.CENTER
                                    },
                                    verticalPosition: {
                                      relative: VerticalPositionRelativeFrom.PAGE,
                                      align: VerticalPositionAlign.CENTER
                                    },
                                    wrap: {
                                      type: TextWrappingType.BEHIND_TEXT
                                    },
                                    allowOverlap: true,
                                    behindDocument: true
                                  }
                                })
                              ]
                            })
                          ]
                        })
                      } : undefined,
                      children: documentSections
                    }
                  ]
                });
         
              
                 Packer.toBlob(doc).then(blob => {
                   resolve(blob);
                 }).catch(error => {
                   console.error("Error generating Word blob:", error);
                   reject(error);
                 });
                 });
         
               }).catch(error => {
                 console.error("Error fetching logo:", error);
                 reject(error);
               });
         
             } catch (error) {
               console.error("Error generating Word blob:", error);
               reject(error);
             }
           });
         };
  


const generateReferences = (winding) => {
  const base = ["Primary - Earth", "Primary - Core 1"];
  const coreCount = winding.startsWith("da") ? 5 : parseInt(winding[0]);

  for (let i = 2; i <= coreCount; i++) {
    base.push(`Primary - Core ${i}`);
  }

  for (let i = 1; i <= coreCount; i++) {
    for (let j = i + 1; j <= coreCount; j++) {
      base.push(`Core ${i} - Core ${j}`);
    }
  }

  for (let i = 1; i <= coreCount; i++) {
    base.push(`Core ${i} - Earth`);
  }

  return base;
};

return (
  <div className="pt-1001">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <h2 className="pt-1002">PT CHECK LIST</h2>
    <span 
        style={{ 
          fontSize: '20px', 
          fontWeight: '600', 
          color: '#333', 
          cursor: 'pointer',
          marginRight: '20px',
          marginBottom: '50px'
        }}
        onClick={redirectToHome}
      >
        X
      </span>
      </div>
    
    {errorMessage && (
      <div className="pt-1003">
        {errorMessage}
      </div>
    )}
    
    <div className="pt-1004">      
      {checkpoints.map((checkpoint, index) => (
        <div className="pt-1005" key={index}>
          <div className="pt-1006">{checkpoint}</div>
          <div className="pt-1007">
            <select
              value={checklist[index]}
              onChange={(e) => handleSelectChange(index, e.target.value)}
              className="pt-1008"
            >
              <option value="">Select Status</option>
              <option value="OK">OK</option>
              <option value="NOT OK">NOT OK</option>
            </select>
          </div>
        </div>
      ))}
    </div>
    
    <div className="pt-1009">
      <button type="button" onClick={goBack} disabled={isLoading} className="pt-1010">Back</button>
      <button type="button" onClick={handleSubmit} disabled={isLoading} className="pt-1011">
        {isLoading ? "Processing..." : "Submit"}
      </button>

      {formSubmitted && (
        <button 
        type="button"
        className="pt-1012" 
        onClick={handleDownloadPdf}
        disabled={isLoading}
        style={{ 
          marginLeft: '10px', 
          backgroundColor: '#4CAF50', 
          cursor: isLoading ? 'not-allowed' : 'pointer' 
        }}
      >
        Download Word
      </button>
      )}
      
    </div>
  </div>
);
};

export default VTList;


